import proxyPolyfill from './proxy';

type ProxyContainer = <T extends object = object, K extends object = object>(
    services: T,
    handler: K,
) => T;

export const proxyContainer: ProxyContainer = (services, handler) => {
    if (!window.Proxy) {
        const ProxyPolyfill: any = proxyPolyfill();
        return new ProxyPolyfill(services, handler);
    }

    return new Proxy(services, handler);
};
